import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const ReportOptions = ({ name, isTxn, isLabel, label, isSelection, setOnSelect, placeholder, userProps, width, getvalue: callback, index, type, setFieldValue, values}, props) => {

    const getSelectedValue = (values) => {
        // console.log("Vtype Selected", values)
        setOnSelect(values)
    }
 

    const options = [
        { key: 1, text: 'DMS To RLB Posting Log', value: 'DMS To RLB posting log' },
        { key: 2, text: 'Exceptions - UIN', value: 'exception_report_uin' },
        { key: 3, text: 'Exceptions - Unregistered', value: 'exception_report_unreg25k' },
        { key: 4, text: 'Exceptions - GST Taxable Value', value: 'exception_report_gst_taxable' },
        { key: 5, text: 'Exceptions - WC WI', value: 'exception_report_wc_wi' },
        { key: 6, text: 'Reconciliation', value: 'Reconciliation' }
    ]


    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue: getSelectedValue, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default ReportOptions;